/**
 * DEV-1932. Раздел «Документы» сделки — единое хранилище.
 *
 * Отдельным модулем, как documentTypes: общий ru.ts правят несколько эпиков сразу, а
 * этим ключам нужен только раздел документов.
 */

const ruStorage = {
  title: 'Все документы сделки',
  subtitle: 'загруженные файлы и созданные из шаблонов',
  upload: 'Загрузить',
  dropHint: 'Перетащите файлы сюда или нажмите, чтобы выбрать',
  generate: 'Из шаблона',
  preview: 'Просмотр',
  download: 'Скачать',
  rename: 'Переименовать',
  changeType: 'Тип документа',
  changeTypeHint: 'Смена типа отправит документ на проверку заново, прежнее решение будет снято.',
  typeChanged: 'Тип документа изменён',
  typeChangeError: 'Не удалось изменить тип документа',
  rowActions: 'Действия с документом',
  noType: 'Без типа',
  noPreview: 'Предпросмотр для этого формата недоступен',
  previewFailed: 'Не удалось загрузить предпросмотр',
  documentTitle: 'Документ',
  columns: {
    name: 'Название',
    type: 'Тип',
    status: 'Проверка',
    source: 'Откуда',
    uploaded: 'Добавлен',
    size: 'Размер',
  },
  source: {
    upload: 'Загружен',
    generated: 'Шаблон',
  },
  empty: {
    title: 'Документов пока нет',
    description: 'Загрузите файл или создайте документ из шаблона',
    filtered: 'По выбранным фильтрам ничего не нашлось',
  },
  deleteConfirm: {
    title: 'Удалить документ?',
    description: '«{name}» исчезнет из сделки. Отменить это нельзя.',
  },
}

const enStorage = {
  title: 'All deal documents',
  subtitle: 'uploaded files and documents built from templates',
  upload: 'Upload',
  dropHint: 'Drop files here or click to choose',
  generate: 'From template',
  preview: 'Preview',
  download: 'Download',
  rename: 'Rename',
  changeType: 'Document type',
  changeTypeHint:
    'Changing the type sends the document for a new check; the previous verdict is dropped.',
  typeChanged: 'Document type changed',
  typeChangeError: 'Failed to change the document type',
  rowActions: 'Document actions',
  noType: 'No type',
  noPreview: 'Preview is not available for this format',
  previewFailed: 'Could not load the preview',
  documentTitle: 'Document',
  columns: {
    name: 'Name',
    type: 'Type',
    status: 'Check',
    source: 'Origin',
    uploaded: 'Added',
    size: 'Size',
  },
  source: {
    upload: 'Uploaded',
    generated: 'Template',
  },
  empty: {
    title: 'No documents yet',
    description: 'Upload a file or build a document from a template',
    filtered: 'Nothing matches the selected filters',
  },
  deleteConfirm: {
    title: 'Delete the document?',
    description: '“{name}” will disappear from the deal. This cannot be undone.',
  },
}

const vnStorage = {
  title: 'Tất cả tài liệu của giao dịch',
  subtitle: 'tệp đã tải lên và tài liệu tạo từ mẫu',
  upload: 'Tải lên',
  dropHint: 'Kéo tệp vào đây hoặc bấm để chọn',
  generate: 'Từ mẫu',
  preview: 'Xem trước',
  download: 'Tải xuống',
  rename: 'Đổi tên',
  changeType: 'Loại tài liệu',
  changeTypeHint: 'Đổi loại sẽ gửi tài liệu đi kiểm tra lại, quyết định trước đó bị huỷ.',
  typeChanged: 'Đã đổi loại tài liệu',
  typeChangeError: 'Không đổi được loại tài liệu',
  rowActions: 'Thao tác với tài liệu',
  noType: 'Không có loại',
  noPreview: 'Không xem trước được định dạng này',
  previewFailed: 'Không tải được bản xem trước',
  documentTitle: 'Tài liệu',
  columns: {
    name: 'Tên',
    type: 'Loại',
    status: 'Kiểm tra',
    source: 'Nguồn',
    uploaded: 'Đã thêm',
    size: 'Dung lượng',
  },
  source: {
    upload: 'Đã tải lên',
    generated: 'Mẫu',
  },
  empty: {
    title: 'Chưa có tài liệu',
    description: 'Hãy tải tệp lên hoặc tạo tài liệu từ mẫu',
    filtered: 'Không có gì khớp với bộ lọc đã chọn',
  },
  deleteConfirm: {
    title: 'Xoá tài liệu?',
    description: '«{name}» sẽ biến mất khỏi giao dịch. Không thể hoàn tác.',
  },
}

// Карточка документа: замечания проверки и распознанные поля.
const ruDocuments = {
  issuesTitle: 'Замечания проверки',
  fieldsTitle: 'Распознанные поля ({n})',
  storageLine: 'Документы этапа: {done} / {total} подтверждено — открыть →',
}
const enDocuments = {
  issuesTitle: 'Check remarks',
  fieldsTitle: 'Recognised fields ({n})',
  storageLine: 'Stage documents: {done} / {total} approved — open →',
}
const vnDocuments = {
  issuesTitle: 'Nhận xét khi kiểm tra',
  fieldsTitle: 'Trường đã nhận dạng ({n})',
  storageLine: 'Tài liệu giai đoạn: đã xác nhận {done} / {total} — mở →',
}

export const dealStorageMessages = {
  ru: { deals: { detail: { storage: ruStorage, documents: ruDocuments } } },
  en: { deals: { detail: { storage: enStorage, documents: enDocuments } } },
  vn: { deals: { detail: { storage: vnStorage, documents: vnDocuments } } },
}
